import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "sonner";

import { deXuatNhaCungCapApi } from "src/1/apis/de_xuat_nha_cung_cap.api";
import { history } from "src/App";

import { MarkInfo, MarkTable, MarkToolbar } from "../../components";
import { markDefaulValues as defaultValues } from "../../form";

const ChamDiemDeXuatNhaCungCap = () => {
  //#region Data
  const params = useParams();

  const [roleId, setRoleId] = useState("");

  const { data } = useQuery({
    queryKey: ["chi-tiet-diem-ncc", params?.id, params?.supplierId, roleId],
    queryFn: () =>
      deXuatNhaCungCapApi.getSupplierById(
        params?.id,
        params?.supplierId,
        roleId,
      ),
    enabled: Boolean(params?.supplierId && params?.id),
    select: (response) => response?.data?.data,
  });

  const { data: approvers = [] } = useQuery({
    queryKey: ["danh-sach-nhom-duyet", params?.id, params?.supplierId],
    queryFn: () =>
      deXuatNhaCungCapApi.getSuppliers(params?.id, params?.supplierId),
    enabled: Boolean(params?.supplierId && params?.id),
    select: (response) =>
      response?.data?.data?.map((e) => ({
        ...e,
        value: e?.id,
        label: e?.role_name,
      })),
  });

  const {
    control,
    watch,
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    mode: "all",
    defaultValues,
  });
  //#endregion

  //#region Event
  const onSubmit = handleSubmit(async (values) => {
    try {
      const payload = {
        evaluations: values?.evaluations,
        ...(data?.is_approval &&
          data?.is_final_step && {
            decision: Number(values?.decision),
            final_note: values?.final_note,
          }),
      };

      await deXuatNhaCungCapApi.approveSupplier(
        params?.id,
        params?.supplierId,
        payload,
      );

      toast.success("Chấm điểm nhà cung cấp thành công!");
      reset(defaultValues);
      history.push(`/supplier-suggest/rating/${params?.id}`);
    } catch (error) {
      toast.error(error?.message || "Chấm điểm không thành công!");
    }
  });
  //#endregion

  useEffect(() => {
    if (data) {
      reset({ ...data });
    }
  }, [data]);

  //#region Render
  return (
    <div className="flex flex-col">
      <MarkToolbar
        onSubmit={onSubmit}
        isLoading={isSubmitting}
        canSave={data?.is_approval}
      />

      <MarkInfo watch={watch} />

      <MarkTable
        control={control}
        approvers={approvers}
        roleId={roleId}
        setRoleId={setRoleId}
      />
    </div>
  );
  //#endregion
};
export default ChamDiemDeXuatNhaCungCap;
